import { render, staticRenderFns } from "./hidden-container.vue?vue&type=template&id=65ff0034&"
import script from "./hidden-container.vue?vue&type=script&lang=js&"
export * from "./hidden-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports